module.exports = __webpack_public_path__ + "static/media/fire_adept_staff.6512a81d.png";